module.exports = __webpack_public_path__ + "img/SELFEE_80X30.fdd9e08c.png";